export default class Config {
    constructor(setup){
        this.camera = {
            VIEW_ANGLE: 37,
            NEAR: 0.1,
            FAR: 20000
        };    
        this.object = {
            changeMaterials: [],
            name: '',
            parts: 1,
            scale: 1,
            slots: []
        };
        this.project = {
            name: "",
            basedir: 'http://'+window.location.host+'/',
            folder: 'project/',
            introText: ''
        };
        this.surrounding = {
            background: '',
            environment: 'washroom-mosaic',
            fogColor: 0xafc1ff
        };
        this.tech = {
            debug: true,
            showHighlight: true,
            useFloatingLight: false,
            usePostProcessing: false,
            useSky: false,
            useSkyBox: true,
            useVideo: false,
            useWireframe: false
        };
        this.highlights = [];
        this.materials = [];
        this.lightSetups = [
            {
                "id": 1,
                "name": "Default",
                "lights": [
                    {
                        "id": 13,
                        "type": "Spot",
                        "color": "#ffffff",
                        "hasShadow": true,
                        "onlyShadow": false,
                        "castShadow": true,
                        "shadowMap": 4096,
                        "shadowDarkness": 0.04,
                        "shadowNear": 1,
                        "shadowFar": 25,
                        "intensity": 1,
                        "pos": {
                            "x": 10,
                            "y": 10,
                            "z": 10
                        },
                        "dir": {
                            "x": 0,
                            "y": 0,
                            "z": 0
                        }
                    },
                    {
                        "id": 14,
                        "type": "Spot",
                        "color": "#ffffff",
                        "hasShadow": false,
                        "onlyShadow": false,
                        "castShadow": false,
                        "shadowMap": 0,
                        "shadowDarkness": 0,
                        "shadowNear": 0,
                        "shadowFar": 0,
                        "intensity": 0.8,
                        "pos": {
                            "x": 2,
                            "y": 0,
                            "z": -10
                        },
                        "dir": {
                            "x": 0,
                            "y": 0,
                            "z": 0
                        }
                    },
                    {
                        "id": 15,
                        "type": "Spot",
                        "color": "#ffffff",
                        "hasShadow": false,
                        "onlyShadow": false,
                        "castShadow": false,
                        "shadowMap": 0,
                        "shadowDarkness": 0,
                        "shadowNear": 0,
                        "shadowFar": 0,
                        "intensity": 0.8,
                        "pos": {
                            "x": -10,
                            "y": 5,
                            "z": 3
                        },
                        "dir": {
                            "x": 0,
                            "y": 0,
                            "z": 0
                        }
                    },
                    {
                        "id": 16,
                        "type": "Spot",
                        "color": "#666666",
                        "hasShadow": false,
                        "onlyShadow": false,
                        "castShadow": false,
                        "shadowMap": 0,
                        "shadowDarkness": 0,
                        "shadowNear": 0,
                        "shadowFar": 0,
                        "intensity": 0.8,
                        "pos": {
                            "x": 2,
                            "y": 0,
                            "z": 15
                        },
                        "dir": {
                            "x": 0,
                            "y": 0,
                            "z": 0
                        }
                    },
                    {
                        "id": 17,
                        "type": "Spot",
                        "color": "#777777",
                        "hasShadow": false,
                        "onlyShadow": false,
                        "castShadow": false,
                        "shadowMap": 0,
                        "shadowDarkness": 0,
                        "shadowNear": 0,
                        "shadowFar": 0,
                        "intensity": 0.8,
                        "pos": {
                            "x": 0,
                            "y": -10,
                            "z": 1
                        },
                        "dir": {
                            "x": 0,
                            "y": 0,
                            "z": 0
                        }
                    },
                    {
                        "id": 18,
                        "type": "Ambient",
                        "color": "#777777",
                        "hasShadow": false,
                        "onlyShadow": false,
                        "castShadow": false,
                        "shadowMap": 0,
                        "shadowDarkness": 0,
                        "shadowNear": 0,
                        "shadowFar": 0,
                        "intensity": 0.2,
                        "pos": {
                            "x": 0,
                            "y": 0,
                            "z": 0
                        },
                        "dir": {
                            "x": 0,
                            "y": 0,
                            "z": 0
                        }
                    }
                ]
            },
            {
                "id": 2,
                "name": "Shadow only",
                "lights": [
                    {
                        "id": 19,
                        "type": "Spot",
                        "color": "#ffffff",
                        "hasShadow": false,
                        "onlyShadow": false,
                        "castShadow": true,
                        "shadowMap": 4096,
                        "shadowDarkness": 0.04,
                        "shadowNear": 1,
                        "shadowFar": 25,
                        "intensity": 1,
                        "pos": {
                            "x": 10,
                            "y": 10,
                            "z": 10
                        },
                        "dir": {
                            "x": 0,
                            "y": 0,
                            "z": 0
                        }
                    }
                ]
            },
            {
                "id": 3,
                "name": "Ambient",
                "lights": [
                    {
                        "id": 20,
                        "type": "Ambient",
                        "color": "#ffffff",
                        "hasShadow": false,
                        "onlyShadow": false,
                        "castShadow": false,
                        "shadowMap": 0,
                        "shadowDarkness": 0,
                        "shadowNear": 0,
                        "shadowFar": 0,
                        "intensity": 1,
                        "pos": {
                            "x": 0,
                            "y": 0,
                            "z": 0
                        },
                        "dir": {
                            "x": 0,
                            "y": 0,
                            "z": 0
                        }
                    }
                ]
            },
            {
                "id": 4,
                "name": "Circle Rig",
                "lights": [
                    {
                        "id": 21,
                        "type": "Spot",
                        "color": "#ffffff",
                        "hasShadow": false,
                        "onlyShadow": false,
                        "castShadow": false,
                        "shadowMap": 0,
                        "shadowDarkness": 0,
                        "shadowNear": 0,
                        "shadowFar": 0,
                        "intensity": 1,
                        "pos": {
                            "x": 0,
                            "y": 5,
                            "z": 20
                        },
                        "dir": {
                            "x": 0,
                            "y": 0,
                            "z": 0
                        }
                    },
                    {
                        "id": 22,
                        "type": "Spot",
                        "color": "#ffffff",
                        "hasShadow": false,
                        "onlyShadow": false,
                        "castShadow": false,
                        "shadowMap": 0,
                        "shadowDarkness": 0,
                        "shadowNear": 0,
                        "shadowFar": 0,
                        "intensity": 1,
                        "pos": {
                            "x": 20,
                            "y": 5,
                            "z": 0
                        },
                        "dir": {
                            "x": 0,
                            "y": 0,
                            "z": 0
                        }
                    },
                    {
                        "id": 23,
                        "type": "Spot",
                        "color": "#ffffff",
                        "hasShadow": false,
                        "onlyShadow": false,
                        "castShadow": false,
                        "shadowMap": 0,
                        "shadowDarkness": 0,
                        "shadowNear": 0,
                        "shadowFar": 0,
                        "intensity": 1,
                        "pos": {
                            "x": -20,
                            "y": 5,
                            "z": 0
                        },
                        "dir": {
                            "x": 0,
                            "y": 0,
                            "z": 0
                        }
                    },
                    {
                        "id": 24,
                        "type": "Spot",
                        "color": "#ffffff",
                        "hasShadow": false,
                        "onlyShadow": false,
                        "castShadow": false,
                        "shadowMap": 0,
                        "shadowDarkness": 0,
                        "shadowNear": 0,
                        "shadowFar": 0,
                        "intensity": 1,
                        "pos": {
                            "x": 0,
                            "y": 5,
                            "z": -20
                        },
                        "dir": {
                            "x": 0,
                            "y": 0,
                            "z": 0
                        }
                    },
                    {
                        "id": 25,
                        "type": "Spot",
                        "color": "#ffffff",
                        "hasShadow": false,
                        "onlyShadow": false,
                        "castShadow": false,
                        "shadowMap": 0,
                        "shadowDarkness": 0,
                        "shadowNear": 0,
                        "shadowFar": 0,
                        "intensity": 1,
                        "pos": {
                            "x": 15,
                            "y": 5,
                            "z": 15
                        },
                        "dir": {
                            "x": 0,
                            "y": 0,
                            "z": 0
                        }
                    },
                    {
                        "id": 26,
                        "type": "Spot",
                        "color": "#ffffff",
                        "hasShadow": false,
                        "onlyShadow": false,
                        "castShadow": false,
                        "shadowMap": 0,
                        "shadowDarkness": 0,
                        "shadowNear": 0,
                        "shadowFar": 0,
                        "intensity": 1,
                        "pos": {
                            "x": 15,
                            "y": 5,
                            "z": -15
                        },
                        "dir": {
                            "x": 0,
                            "y": 0,
                            "z": 0
                        }
                    },
                    {
                        "id": 27,
                        "type": "Spot",
                        "color": "#ffffff",
                        "hasShadow": false,
                        "onlyShadow": false,
                        "castShadow": false,
                        "shadowMap": 0,
                        "shadowDarkness": 0,
                        "shadowNear": 0,
                        "shadowFar": 0,
                        "intensity": 1,
                        "pos": {
                            "x": -15,
                            "y": 5,
                            "z": 15
                        },
                        "dir": {
                            "x": 0,
                            "y": 0,
                            "z": 0
                        }
                    },
                    {
                        "id": 28,
                        "type": "Spot",
                        "color": "#ffffff",
                        "hasShadow": false,
                        "onlyShadow": false,
                        "castShadow": false,
                        "shadowMap": 0,
                        "shadowDarkness": 0,
                        "shadowNear": 0,
                        "shadowFar": 0,
                        "intensity": 1,
                        "pos": {
                            "x": -15,
                            "y": 5,
                            "z": -15
                        },
                        "dir": {
                            "x": 0,
                            "y": 0,
                            "z": 0
                        }
                    }
                ]
            }
        ];
        this.environments = [
            {
                "id": 1,
                "name": "Default",
                "folder": "default"
            },
            {
                "id": 2,
                "name": "Warped",
                "folder": "warped"
            },
            {
                "id": 3,
                "name": "Washroom Mosaic",
                "folder": "washroom-mosaic"
            }
        ];
        
        const scope = this;
        Object.keys(setup).map(function(key, index) {
            scope[key] = setup[key];
        });
    }
};


// WEBPACK FOOTER //
// ./src/js/studio/model/Config.js